import { Component, OnInit, OnDestroy } from "@angular/core";
import { ProgressBarService } from "./progress-bar.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-progress-bar",
  templateUrl: "./progress-bar.component.html",
  styleUrls: ["./progress-bar.component.scss"],
  standalone: false,
})
export class ProgressBarComponent implements OnInit, OnDestroy {
  isLoading = false;
  private subscription: Subscription;

  constructor(private progressBarService: ProgressBarService) {}

  ngOnInit(): void {
    this.subscription = this.progressBarService
      .isLoading()
      .subscribe((loading: boolean) => {
        this.isLoading = loading;
      });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
